import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import { computed } from 'vue';
import { abbreviateNumber } from '~/assets/helper/functions';
import { AnnualAggregationMethod } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'MetricValue',
  props: {
    metric: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    metricValue: {
      type: Object,
      required: true
    },
    annualAggregationMethod: {
      type: String,
      default: function _default() {
        return AnnualAggregationMethod.Avg;
      }
    }
  },
  emits: ["click"],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useNuxtApp = useNuxtApp(),
      i18n = _useNuxtApp.$i18n;
    var isAggregation = computed(function () {
      var _props$metricValue;
      return ((_props$metricValue = props.metricValue) === null || _props$metricValue === void 0 ? void 0 : _props$metricValue.__typename) === 'MetricAggregationValueType';
    });
    var isComputedMetric = computed(function () {
      var _props$metric;
      return !!((_props$metric = props.metric) !== null && _props$metric !== void 0 && _props$metric.isComputed);
    });
    var currentreportingPeriod = computed(function () {
      var currentYear = new Date().getFullYear();
      return (currentYear - 1).toString();
    });
    var isEmptyMetricValue = computed(function () {
      var v = props.metricValue;
      if (!v || Object.keys(v).length === 0) return true;
      var actualNull = v.actual == null;
      var textNull = v.text == null;
      var noOptions = !(v.options && v.options.length);
      return actualNull && textNull && noOptions;
    });
    var hasTarget = computed(function () {
      var v = props.metricValue;
      return !!(v && v.target != null);
    });
    var metricValueComment = computed(function () {
      var v = props.metricValue;
      return v && v.comment ? v.comment : '';
    });
    var showPeriodMatchTooltip = computed(function () {
      var _props$metricValue2;
      return isAggregation.value && ((_props$metricValue2 = props.metricValue) === null || _props$metricValue2 === void 0 ? void 0 : _props$metricValue2.period) && props.metricValue.period === currentreportingPeriod.value;
    });
    var formatNumber = function formatNumber(num, locale) {
      if (num === null) {
        // if we run Number(null) it will return 0, so this is an edge case
        return '⋯';
      }
      num = Number(num);
      if (isNaN(num)) {
        return '⋯';
      }
      return abbreviateNumber(num, locale);
    };
    var actualCompletionRate = computed(function () {
      var mv = props.metricValue;
      if ((mv === null || mv === void 0 ? void 0 : mv.period) !== currentreportingPeriod.value) {
        return null;
      }
      if (!isAggregation.value) return '';
      var txt = '';
      var actualCompletedLength = (mv.actualCompleted || []).length;
      var requiredLength = (mv.required || []).length;
      if (requiredLength === 0) {
        return '';
      }
      txt += "Completion rate: ".concat(formatNumber(actualCompletedLength / requiredLength * 100, i18n.locale), "%.<br>").concat(actualCompletedLength, " out of ").concat(requiredLength, " companies entered data.");
      return txt;
    });
    var onCardClick = function onCardClick(event) {
      if (isComputedMetric.value) return;
      emit('click', event);
    };
    return {
      __sfc: true,
      props: props,
      emit: emit,
      i18n: i18n,
      isAggregation: isAggregation,
      isComputedMetric: isComputedMetric,
      currentreportingPeriod: currentreportingPeriod,
      isEmptyMetricValue: isEmptyMetricValue,
      hasTarget: hasTarget,
      metricValueComment: metricValueComment,
      showPeriodMatchTooltip: showPeriodMatchTooltip,
      formatNumber: formatNumber,
      actualCompletionRate: actualCompletionRate,
      onCardClick: onCardClick,
      AnnualAggregationMethod: AnnualAggregationMethod
    };
  }
});